const form = {
  formId: "new-user-form",
  formField: {
    taxpayersName: {
      name: "taxpayersName",
      label: "Người nộp thuế",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên người nộp thuế",
    },
    taxpayersId: {
      name: "taxpayersId",
      label: "Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    taxAgentName: {
      name: "taxAgentName",
      label: "Tên đại lý thuế (nếu có)",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng nhập tên đại lý thuế",
    },
    taxAgentId: {
      name: "taxAgentId",
      label: "Mã số thuế:",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập mã số thuế",
      invalidMsg: "Mã số thuế không hợp lệ",
    },
    bctc: {
      name: "bctc",
      label: "BCTC đã được kiểm toán",
      type: "text",
    },
    htldl: {
      name: "htldl",
      label: "Hỗ trợ lấy dữ liệu từ năm trước",
      type: "text",
    },
    tctm: {
      name: "tctm",
      label: "Tích chọn để nhập cột thuyết minh",
      type: "text",
    },
    auditOpinion: {
      name: "auditOpinion",
      label: "Ý kiến kiểm toán",
      type: "text",
      placeholder: "Chọn",
      errorMsg: "Vui lòng chọn",
    },
    //--------------//
    fullName: {
      name: "fullName",
      label: "Người lập biểu",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên người lập biểu",
    },
    chiefAccountant: {
      name: "chiefAccountant",
      label: "Kế toán trưởng",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên kế toán trưởng",
    },
    signer: {
      name: "signer",
      label: "Người đại diện theo pháp luật",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên người đại diện theo pháp luật",
    },
    timeSign: {
      name: "timeSign",
      label: "Ngày lập",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng chọn ngày lập",
    },
    certificate: {
      name: "certificate",
      label: "Chứng chỉ hành nghề số",
      type: "number",
      placeholder: "",
      errorMsg: "Vui lòng nhập số chứng chỉ hành nghề",
    },
    accountingService: {
      name: "accountingService",
      label: "Đơn vị cung cấp dịch vụ kế toán",
      type: "text",
      placeholder: "",
      errorMsg: "Vui lòng nhập tên đơn vị cung cấp dịch vụ kế toán",
    },
  },
};

export default form;
